import favorite from 'assets/core/js/page/favorite/index'

favorite()
